import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { HowDidYouHearAboutUsOptionInput } from '../../../lib/types/models/how-did-you-hear-about-us-option/how-did-you-hear-about-us-option-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { createStringSchema } from '../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ValidationButtons from '../../elements/validation-buttons'

type HowDidYouHearAboutUsProps = BaseFormProps<HowDidYouHearAboutUsOptionInput> & {
  className?: string
}

const formSchema: ZodType<HowDidYouHearAboutUsOptionInput> = z.object({
  name: createStringSchema('NOM'),
  position: createNumberSchema('position')
})

const HowDidYouHearAboutUsForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: HowDidYouHearAboutUsProps) => {
  const form = useForm<HowDidYouHearAboutUsOptionInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={cn('flex flex-col gap-4', className)}>
          <FormField
            control={form.control}
            name="name"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput required type="text" label="NOM" {...field} />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="position"
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="number" label="Position" required />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}

export default HowDidYouHearAboutUsForm
